import type { ReactNode } from "react";
import { CertificationSectionHeader } from "@modules/certificaciones/shared/ui";

type Props = {
  eyebrow: string;
  title: string;
  description: string;
  onBack: () => void;
  onRefresh: () => void;
  refreshing?: boolean;
  actions?: ReactNode;
};

export function Iso2700127701SectionHeader(props: Props) {
  return <CertificationSectionHeader {...props} standardLabel="ISO 27001-27701" />;
}
